import { render, staticRenderFns } from "./mrecBannerMiddle.vue?vue&type=template&id=60e6fcca&scoped=true&"
import script from "./mrecBannerMiddle.vue?vue&type=script&lang=js&"
export * from "./mrecBannerMiddle.vue?vue&type=script&lang=js&"
import style0 from "./mrecBannerMiddle.vue?vue&type=style&index=0&id=60e6fcca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e6fcca",
  null
  
)

export default component.exports